import {
  WAREHOUSES_PAGINATED_FETCH_STARTED,
  WAREHOUSES_PAGINATED_FETCH_SUCCEEDED,
  WAREHOUSES_PAGINATED_FETCH_FAILED,
  WAREHOUSES_PAGINATED_CHANGE_PAGE,
  WAREHOUSES_PAGINATED_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  page: 1,
  pages: 0,
  order: 'desc',
  orderBy: 'label',
  filterBy: 'label',
  itemsPerPage: 10,
  warehouses: [],
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case WAREHOUSES_PAGINATED_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case WAREHOUSES_PAGINATED_FETCH_SUCCEEDED:
      return {
        ...state,
        status: statuses.succeeded,
        warehouses: action.payload,
        pages: Math.ceil(action.totalCount / state.itemsPerPage),
        totalCount: action.totalCount
      };
    case WAREHOUSES_PAGINATED_CHANGE_PAGE:
      return { ...state, page: action.payload };
    case WAREHOUSES_PAGINATED_FETCH_FAILED:
      return { ...state, status: statuses.failed, warehouses: [], error: action.error };
    case WAREHOUSES_PAGINATED_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
